import React from "react";
import {
  LoginPage,
  ConfirmCodePage,
  ForgotPasswordPage,
  NewPasswordPage,
} from "../../pages/Public";
import { AccountPage, DashboardPage } from "../../pages/Shared";
import {
  UserOutlined,
  AuditOutlined,
} from "@ant-design/icons";
import { RouteBuilder } from "./route-builder";
import SidebarMenuItemApi from "./api/sidebar-menu-item-api";
import { AbstractRouteType } from ".";
import {
  CustomerList as PartnerCustomerList,
  CustomerShow as PartnerCustomerShow,
} from "../../pages/PartnerPage";
import Sidebar from "../../components/Sidebar/Sidebar";
import AppMigrationRequiredPage from "../../pages/Shared/AppMigrationRequired/AppMigrationRequiredPage";
import TermsAndConditionsPage from "../../pages/Public/TermsAndConditionsPage";
import ReportsPage from "../../pages/Shared/ReportsPage";
import DangerzonePage from "../../pages/Shared/DangerzonePage";
import AuthPage from "../../pages/Public/AuthPage/AuthPage";

export type AvailableApis = "sidebar-menu-item-api" | "sidebar-submenu-api";

export const publicRoutes: AbstractRouteType[] = [];

export const partnerRoutes: AbstractRouteType[] = [];

export const customerRoutes: AbstractRouteType[] = [];

export const sharedRoutes: AbstractRouteType[] = [];

const allRoutes: AbstractRouteType[] = [
  RouteBuilder.create()
    .setPath("/login")
    .setExact()
    .seo({
      title: "iLivestock - Login",
    })
    .onRender(() => <LoginPage />)
    .addChild((context, props) => {
      return context.builder
        .setPath(`${props.parent?.path}/new-password`)
        .onRender(() => <NewPasswordPage />);
    })
    .build(),
  RouteBuilder.create()
    .setPath("/confirm-account")
    .setExact()
    .seo({
      title: "iLivestock - Confirm Account",
    })
    .onRender(() => <ConfirmCodePage />)
    .build(),
  RouteBuilder.create()
    .setPath("/forgot-password/reset")
    .setExact()
    .seo({
      title: "iLivestock - Reset Password",
    })
    .onRender(() => <ForgotPasswordPage />)
    .build(),
  RouteBuilder.create()
    .setPath("/forgot-password")
    .setExact()
    .seo({
      title: "iLivestock - Forgotten Password",
    })
    .onRender(() => <ForgotPasswordPage />)
    .build(),
  RouteBuilder.create()
    .setPath("/terms-and-conditions")
    .setExact()
    .seo({
      title: "iLivestock - Terms and conditions",
    })
    .onRender(() => <TermsAndConditionsPage />)
    .build(),
  RouteBuilder.create()
    .setPath("/auth")
    .setExact()
    .seo({
      title: "iLivestock - Authentication",
    })
    .onRender(() => <AuthPage />)
    .build(),
  RouteBuilder.create<AvailableApis>()
    .setPath("/reports")
    .protect()
    .setExact()
    .seo({
      title: "iLivestock - Reports",
    })
    .onRender(() => <ReportsPage />)
    .setRequiredRoles(["dds-admin"])
    .addApi(
      new SidebarMenuItemApi({
        title: () => (
          <>
            <AuditOutlined />
            <span> Reports </span>
          </>
        ),
      })
    )
    .build(),
  RouteBuilder.create<AvailableApis>()
    .setPath("/app-migration-required")
    .protect()
    .setExact()
    .onRender(() => <AppMigrationRequiredPage />)
    .build(),
  RouteBuilder.create<AvailableApis>()
    .setPath("/")
    .protect()
    .setExact()
    .seo({
      title: "iLivestock - Trade Partner Customers",
    })
    .onRender(() => <Sidebar content={() => <PartnerCustomerList />} />)
    .setRequiredRoles(["partners"])
    .addApi(
      new SidebarMenuItemApi({
        title: () => (
          <>
            <AuditOutlined />
            <span> Trade partner </span>
          </>
        ),
      })
    )
    .addChild((context, props) => {
      return context.builder
        .setPath(`${props.parent?.path}customers/:sub`)
        .setExact()
        .seo({
          title: "iLivestock - Trade Partner View Customer",
        })
        .protect()
        .setRequiredRoles(["partners"])
        .onRender(() => <Sidebar content={() => <PartnerCustomerShow />} />);
    })
    .build(),
  RouteBuilder.create()
    .setPath("/account")
    .setExact()
    .seo({
      title: "iLivestock - Account",
    })
    .protect()
    .onRender(() => <AccountPage />)
    .addApi(
      new SidebarMenuItemApi({
        title: () => (
          <>
            <UserOutlined />
            <span> Account </span>
          </>
        ),
      })
    )
    .build(),
  RouteBuilder.create()
    .setPath("/danger-zone")
    .setExact()
    .seo({
      title: "iLivestock - DANGER ZONE",
    })
    .setRequiredRoles(["dds-admin"])
    .protect()
    .onRender(() => <DangerzonePage />)
    .addApi(
      new SidebarMenuItemApi({
        title: () => (
          <>
            ☠️
            <span> Danger Zone </span>
          </>
        ),
      })
    )
    .build(),
];

export const routes: AbstractRouteType[] = [
  ...allRoutes,
  // TODO create 404 page
  RouteBuilder.create().onRender(() => <div>404</div>),
];
